import { useEffect, useState } from 'react'
import { Item } from '../../../../../../utils/types/generals'
import { getUsers } from '../../../../../../utils/methods/geServiceWithItemsFormat'
import { Roles } from '../../../../../../utils/enums'
import { User } from '../../../../../../service/user/response'
import { loogbookServiceFetch } from '../../../../../../utils/constants/callService'
import { formatUserAccessResponse } from '../../../../../../service/logbook/format'
import { useTranslation } from 'react-i18next'


const useGetData = () => {
  const { t } = useTranslation()
  const [userTable, setUserTable] = useState<{ [x: string]: any }[]>([])
  const [loadingTable, setLoadingTable] = useState(false)

  const [dataEndpoint, setDataEndpoint] = useState<{
    accessWeb: boolean,
    accessMobile: boolean,
    accessShowReport: boolean,
    accessResendReport: boolean,
    userId: number,
    firstName: string,
    lastName: string,
    fullName: string,
    area:string,
    department:string
  }[]
  >([])

  const getData = () => {
    getUserServices()
    getAccesData()
  }

  const getUserServices = async (payload?: { responsible: Item }) => {
    setLoadingTable(true)
    const { items, all } = await getUsers({ skip: [Roles.ADMIN] })
    let itemsResponsible = structuredClone(items) as Item[]

    if (!!payload?.responsible && !items?.some(item => item.value == payload?.responsible?.value)) {
      itemsResponsible.push(payload.responsible)
    }

    setUserTable(
      (all as User[])?.map((itemUsers) => ({
        id: itemUsers.id,
        name: `${itemUsers.firstName} ${itemUsers.lastName}`,
        curp: itemUsers.curp,
        role: itemUsers.roleId,
        roleName: itemUsers.role,
        userType: itemUsers.userTypeId,
        areaId: itemUsers.areaId,
        areaName: itemUsers.areaName,
        departmentId: itemUsers.departmentId,
        departmentName: itemUsers.departmentName
      }))
    )

    setLoadingTable(false)
  }

  const getAccesData = async () => {
      const response = await loogbookServiceFetch.getLogbookAccess()
      const { row } = formatUserAccessResponse({response,t})
      setDataEndpoint(row)
  }

  useEffect(() => {
    getData()
  }, [])
  return { loadingTable, userTable, dataEndpoint }
}

export { useGetData }
